import {Button} from 'design'
import type {ButtonProps} from 'design/Button'
import {AlertBannerAction} from 'interfaces'
import {RenderIf} from 'components'

export type AlertBannerActionsProps = {
  primary?: AlertBannerAction
  secondary?: AlertBannerAction
}

type CommonActionButtonProps = Pick<
  ButtonProps,
  'size' | 'variant' | 'colorScheme' | 'borderRadius' | 'className'
>

export const AlertBannerActions = ({
  primary,
  secondary,
}: AlertBannerActionsProps): JSX.Element => {
  const commonButtonProps: CommonActionButtonProps = {
    size: 'sm',
    variant: 'outline',
    colorScheme: 'gray',
    borderRadius: 'rounded',
    className: 'h-8 px-4 whitespace-nowrap',
  }

  return (
    <>
      <RenderIf isTrue={Boolean(secondary)}>
        <Button
          {...commonButtonProps}
          className={`min-w-[5.5rem] ${commonButtonProps.className}`}
          aria-label={secondary?.ariaLabel ?? secondary?.label}
          onClick={secondary?.onClick}
          disabled={secondary?.disabled}
        >
          {secondary?.label}
        </Button>
      </RenderIf>
      <RenderIf isTrue={Boolean(primary)}>
        <Button
          {...commonButtonProps}
          className={`min-w-[10.5rem] ${commonButtonProps.className}`}
          aria-label={primary?.ariaLabel ?? primary?.label}
          onClick={primary?.onClick}
          disabled={primary?.disabled}
        >
          {primary?.label}
        </Button>
      </RenderIf>
    </>
  )
}
